<template>
  <div>
    <el-row>
      <RabbeyTable3
        v-loading="detailTableLoading"
        :columns="columns"
        :data="items"
        style="margin: 20px"
        show-summary
        :summary-method="getSummaries"
      />
    </el-row>

    <el-drawer
      title="Detalle de la Negociacion"
      :visible="openDetail"
      :before-close="CloseTransactionDetail"
      size="60%"
    >
      <el-row style="margin-top: 20px">
        <el-form label-position="top">
          <el-col :span="11" style="margin-left: 20px">
            <el-form-item label="Agente de Ventas">
              <el-input
                v-model="Business.PersonName"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item label="Mes">
              <el-input
                v-model="Business.Month"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <BusinessChart
        ref="detailChart2"
        :DetailParams="DetailData"
        Titulo="Titulo"
        Url="/api/SalesApi/businessChartData"
        SalesCode="32"
        deparmentId="47"
      />

      <rabbey-table-3
        :loading="DrawerLoading"
        :data="itemsDetails"
        :columns="BusinessColum"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script>
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InteractionDetailsHyperLink from "@/components/functionals/InteractionDetailsHyperLink.vue";
import BusinessChart from "@/views/Charts/BusinessChart.vue";

export default {
  name: "Deal-Business-Report",
  props: {
    year: Number
  },
  data() {
    return {
      columns: [
        {
          prop: "Name",
          label: "Vendedor",
          minWidth: 260,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "EmployeePhoto"
          }
        },
        {
          prop: "January",
          label: "Enero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "february",
          label: "Febrero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "march",
          label: "Marzo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "april",
          label: "Abril",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "may",
          label: "Mayo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "june",
          label: "Junio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "july",
          label: "Julio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "august",
          label: "Agosto",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "september",
          label: "Septiembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "october",
          label: "Octubre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "november",
          label: "Noviembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "december",
          label: "Diciembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenInteractionDetail
          }
        },
        {
          prop: "Totals",
          label: "Total"
        }
      ],
      detailTableLoading: false,
      DrawerLoading: false,
      Company: "TB",
      items: [],
      itemsDetails: [],
      openDetail: false,
      Business: [
        {
          PersonName: ""
        },
        {
          Month: ""
        }
      ],
      BusinessColum: [
        {
          prop: "NameDeals",
          label: "Negociacion",
          minWidth: 260
        },
        {
          prop: "Description",
          label: "Descripcion Negociacion",
          minWidth: 260
        },
        {
          prop: "ContacName",
          label: "Contacto",
          minWidth: 260
        },
        {
          prop: "Stage",
          label: "Etapa",
          minWidth: 260
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          minWidth: 260
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 260
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          minWidth: 260
        }
      ],
      DetailData: {
        Year: 0,
        Month: 0,
        CompanyId: "",
        CreatedBy: 0
      }
    };
  },

  components: {
    RabbeyTable3,
    BusinessChart
  },

  created() {
    this.detailTableLoading = true;
    this.getBusiness(0, 0, 0);
    this.detailTableLoading = false;

    this.loading = true;

    this.$http
      .get("/api/users/GetCustomerServiceSeller", {
        params: {
          DeparmentId: this.select_option
        }
      })
      .then((response) => {
        this.customer_seller = response.data;
      })
      .catch((error) => {
        console.error(error);
      });

    this.loading = false;
  },
  methods: {
    getBusiness(user, month, val) {
      this.$http
        .get("/api/interactions/getBusinessReport", {
          params: {
            Year: this.year,
            CompanyId: this.Company,
            CreatedBy: user,
            Month: month
          }
        })
        .then((resp) => {
          if (val == 0) {
            this.items = resp.data;
          } else {
            this.itemsDetails = resp.data;
            this.$refs.detailChart2.getChartData();
          }
        });
    },

    OpenInteractionDetail(row, column) {
      this.DrawerLoading = true;
      this.Business.PersonName = row.Name;
      this.Business.Month = column;
      this.DetailData = {
        Year: this.year,
        Month: this.getMonthNumber(column),
        CompanyId: this.Company,
        CreatedBy: row.CreatedBy
      };
      this.getBusiness(row.CreatedBy, this.getMonthNumber(column), 1);
      this.openDetail = true;
      this.DrawerLoading = false;
    },

    CloseTransactionDetail() {
      this.openDetail = false;
      this.Business.interactionList = [];
      this.itemsDetails = [];
      this.$refs.detailChart2.bar.series[0].data = [];
      this.$refs.detailChart2.loading = true;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    getMonthNumber(month) {
      switch (month) {
        case "January":
          return 1;
        case "february":
          return 2;
        case "march":
          return 3;
        case "april":
          return 4;
        case "may":
          return 5;
        case "june":
          return 6;
        case "july":
          return 7;
        case "august":
          return 8;
        case "september":
          return 9;
        case "october":
          return 10;
        case "november":
          return 11;
        case "december":
          return 12;
      }
    }
  },

  watch: {
    year() {
      this.getBusiness(0, 0, 0);
    }
  }
};
</script>

<style></style>
